import store from "../../store";
import router from "../../router";
import { MessageBox } from "element-ui";
export default function download(href, title) {
  const token = store.state.token;
  if (token === "") {
    // 未登录，不下载，提示登录
    MessageBox.confirm("下载操作需要登录才能进行，跳转去登录页吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    })
      .then(() => {
        router.push({
          path: "/login",
          query: {
            redirect: router.app.$route.fullPath
          }
        }); /*点击确定，跳转到登录页 */
      })
      .catch(() => {
        /*点击取消，中止操作 */
        return;
      });
  } else {
    // 已登录，继续下载操作
    const a = document.createElement("a");
    a.setAttribute("href", href);
    a.setAttribute("download", title);
    document.body.appendChild(a);
    a.click(); // 点击下载
    document.body.removeChild(a); // 下载完成移除元素
  }
}



// WEBPACK FOOTER //
// ./src/views/pages/download.js